"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[82536],{

/***/ 64673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export Cta */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46675);


function Cta(param) {
    var description = param.description, href = param.href, label = param.label;
    return /*#__PURE__*/ _jsxs("p", {
        className: "flex flex-wrap sm:flex-nowrap lg:flex-wrap xl:flex-nowrap items-center py-6 px-4 sm:p-6 lg:p-10 ring-1 ring-gray-900/5 shadow rounded-lg",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "flex-auto flex items-start mb-8 sm:mb-0 lg:mb-8 xl:mb-0",
                children: [
                    /*#__PURE__*/ _jsx("svg", {
                        viewBox: "0 -4 16 24",
                        fill: "currentColor",
                        className: "flex-none w-4 h-6 mr-4",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4 0a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Zm5 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 7a2 2 0 0 1 2 2v2a1 1 0 1 1-2 0V7Z"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "flex-auto text-sm leading-6 text-gray-600 xl:max-w-2xl",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "flex-none flex justify-center w-full sm:w-auto sm:ml-6 md:ml-8 lg:w-full lg:ml-0 xl:w-auto xl:ml-8",
                children: /*#__PURE__*/ _jsx(Button, {
                    href: href,
                    children: label
                })
            })
        ]
    });
}


/***/ }),

/***/ 41678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ Editor; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/TabBar.js


function TabBar(param) {
    var primary = param.primary, _secondary = param.secondary, secondary = _secondary === void 0 ? [] : _secondary, _showTabMarkers = param.showTabMarkers, showTabMarkers = _showTabMarkers === void 0 ? true : _showTabMarkers, side = param.side, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex text-gray-400 text-xs leading-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-none text-sky-300 border-t border-b border-t-transparent border-b-sky-300 px-4 py-1 flex items-center",
                children: [
                    primary.name,
                    showTabMarkers && (primary.saved ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        viewBox: "0 0 4 4",
                        className: "ml-2.5 flex-none w-1 h-1 text-gray-500 overflow-visible",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M-1 -1L5 5M5 -1L-1 5",
                            fill: "none",
                            stroke: "currentColor",
                            strokeLinecap: "round"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-2.5 flex-none w-1 h-1 rounded-full bg-current"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex-auto flex items-center bg-gray-700/50 border border-gray-500/30", side === "left" ? "rounded-tl lg:rounded-tr" : "rounded-tl"),
                children: [
                    secondary.map(function(param) {
                        var name = param.name, _open = param.open, open = _open === void 0 ? true : _open, className = param.className;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("px-4 py-1 border-r border-gray-200/5", className, {
                                italic: !open
                            }),
                            children: name
                        }, name);
                    }),
                    children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-auto flex items-center justify-end px-4 space-x-4",
                        children: children
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Editor.js


function Editor(param) {
    var filename = param.filename, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-5 mb-8 first:mt-0 last:mb-0 pt-2 bg-gray-800 rounded-xl shadow-lg overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabBar, {
                primary: {
                    name: filename
                },
                showTabMarkers: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "children:my-0",
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 49289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ Steps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/redent/index.js
var redent = __webpack_require__(82931);
var redent_default = /*#__PURE__*/__webpack_require__.n(redent);
// EXTERNAL MODULE: ./node_modules/@reach/alert/dist/reach-alert.esm.js + 6 modules
var reach_alert_esm = __webpack_require__(95877);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.esm.js
var tabs_esm = __webpack_require__(66311);
;// CONCATENATED MODULE: ./src/components/SnippetGroup.js




/**
 * @typedef {React.ReactElement<{ filename?: string }>} CodeBlock
 */ /**
 * Handles styling for a specific ui affordance inside a tab
 *
 * @param {object} props
 * @param {import('clsx').ClassValue} props.className
 */ function TabAdornment(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("pointer-events-none absolute inset-0", className)
    });
}
/**
 * Represents a styled tab in a snippet group that adjusts its style
 * based on the position of this tab relative to the selected tab(s)
 *
 * Also supports an optional marker icon (close or modified)
 *
 * @param {object} props
 * @param {ReactElement[]} props.children
 * @param {number} props.selectedIndex
 * @param {number} props.myIndex
 * @param {"close" | "modified"} [props.marker]
 */ function TabItem(param) {
    var children = param.children, selectedIndex = param.selectedIndex, myIndex = param.myIndex, marker = param.marker;
    var isSelected = selectedIndex === myIndex;
    var isBeforeSelected = selectedIndex === myIndex + 1;
    var isAfterSelected = selectedIndex === myIndex - 1;
    // A cap is the edge of a list of tabs that has a special border treatment
    // The edges of a tab may be in one of three states:
    // - null if selected
    // - normal if it looks like a normal tab
    // - capped if there's a solid rounded corner on that edge
    var edges = {
        leading: isSelected ? null : isAfterSelected ? "capped" : "normal",
        trailing: isSelected ? null : isBeforeSelected ? "capped" : "normal"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab */.O, {
        className: (0,clsx_m/* default */.Z)("flex items-center relative z-10 overflow-hidden px-4 py-1", isSelected ? "text-sky-300" : "text-gray-400"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "z-10",
                children: children
            }),
            marker === "close" && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                viewBox: "0 0 4 4",
                className: "ml-2.5 flex-none w-1 h-1 text-gray-500 overflow-visible",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M-1 -1L5 5M5 -1L-1 5",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round"
                })
            }),
            marker === "modified" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-2.5 flex-none w-1 h-1 rounded-full bg-current"
            }),
            !isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabAdornment, {
                className: (0,clsx_m/* default */.Z)("bg-gray-700/50 border-y border-gray-500/30", edges.leading === "capped" && "border-l rounded-tl", edges.trailing === "capped" && "border-r rounded-tr")
            }),
            edges.trailing === "normal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabAdornment, {
                className: "inset-y-px border-r border-gray-200/5 z-20"
            }),
            isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabAdornment, {
                className: "border-b border-b-sky-300"
            })
        ]
    });
}
/**
 * Group multiple code blocks into a tabbed UI
 *
 * @param {object} props
 * @param {CodeBlock[]} props.children
 */ function SnippetGroup(param) {
    var children = param.children, actions = param.actions;
    var ref = (0,react.useState)(0), selectedIndex = ref[0], setSelectedIndex = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab.Group */.O.Group, {
        as: "div",
        onChange: setSelectedIndex,
        className: "not-prose bg-gray-800 rounded-xl shadow-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.List */.O.List, {
                        className: "flex text-gray-400 text-xs leading-6 overflow-hidden rounded-tl-xl pt-2",
                        children: children.map(function(child, tabIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabItem, {
                                myIndex: tabIndex,
                                selectedIndex: selectedIndex,
                                children: child.props.filename
                            }, child.props.filename);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-auto flex pt-2 rounded-tr-xl overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("flex-auto flex justify-end bg-gray-700/50 border-y border-gray-500/30 pr-4", selectedIndex === children.length - 1 ? "rounded-tl border-l" : "")
                        })
                    }),
                    actions ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-2 right-4 h-8 flex",
                        children: actions({
                            selectedIndex: selectedIndex
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panels */.O.Panels, {
                className: "flex overflow-auto",
                children: children.map(function(child) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panel */.O.Panel, {
                        className: "flex-none min-w-full p-5 text-sm leading-6 text-gray-50 ligatures-none",
                        children: child.props.children
                    }, child.props.filename);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Editor.js + 1 modules
var Editor = __webpack_require__(41678);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 4 modules
var transition_esm = __webpack_require__(35131);
;// CONCATENATED MODULE: ./src/components/Steps.js








function Steps(param) {
    var steps = param.steps, code = param.code;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            className: "max-w-[500px] md:max-w-[400px] lg:max-w-[600px] relative space-y-2 mb-16",
            style: {
                counterReset: "step"
            },
            children: steps.map(function(step, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: (0,clsx_m/* default */.Z)("relative pl-10 xl:grid grid-cols-5 gap-16 before:content-[counter(step)] before:absolute before:left-0 before:flex before:items-center before:justify-center before:w-[calc(1.375rem+1px)] before:h-[calc(1.375rem+1px)] before:text-[0.625rem] before:font-bold before:text-gray-700 before:rounded-md before:shadow-sm before:ring-1 before:ring-gray-900/5", index !== steps.length - 1 && "pb-8 after:absolute after:top-[calc(1.875rem+1px)] after:bottom-0 after:left-[0.6875rem] after:w-px after:bg-gray-200"),
                    style: {
                        counterIncrement: "step"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6 col-span-2 xl:mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-sm leading-6 text-gray-900 font-semibold mb-2",
                                    children: step.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "prose prose-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(step.body, {})
                                })
                            ]
                        }),
                        step.code && /*#__PURE__*/ (0,jsx_runtime.jsx)(Snippet, {
                            code: step.code,
                            highlightedCode: code[index]
                        })
                    ]
                }, step.title);
            })
        })
    });
}
function CopyButton(param) {
    var code = param.code;
    var ref = (0,react.useState)({
        state: "idle",
        i: 0
    }), ref1 = ref[0], state = ref1.state, i = ref1.i, setState = ref[1];
    (0,react.useEffect)(function() {
        if (state === "copied") {
            var handle = window.setTimeout(function() {
                setState({
                    state: "idle",
                    i: i + 1
                });
            }, 1500);
            return function() {
                window.clearTimeout(handle);
            };
        }
    }, [
        state,
        i
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex -mr-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (0,clsx_m/* default */.Z)({
                    "text-gray-500 hover:text-gray-400": state === "idle",
                    "text-sky-400": state === "copied"
                }),
                onClick: function() {
                    navigator.clipboard.writeText(redent_default()(code.replace(/^[+->]/gm, " "))).then(function() {
                        setState({
                            state: "copied",
                            i: i + 1
                        });
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    "aria-hidden": "true",
                    className: "w-8 h-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M13 10.75h-1.25a2 2 0 0 0-2 2v8.5a2 2 0 0 0 2 2h8.5a2 2 0 0 0 2-2v-8.5a2 2 0 0 0-2-2H19"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M18 12.25h-4a1 1 0 0 1-1-1v-1.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1ZM13.75 16.25h4.5M13.75 19.25h4.5"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                className: "absolute bottom-full left-1/2 mb-3.5 pb-1 -translate-x-1/2",
                show: state === "copied",
                enter: "transform ease-out duration-200 transition origin-bottom",
                enterFrom: "scale-95 translate-y-0.5 opacity-0",
                enterTo: "scale-100 translate-y-0 opacity-100",
                leave: "transition ease-in duration-100",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(reach_alert_esm/* default */.Z, {
                    className: "relative bg-sky-500 text-white font-mono text-[0.625rem] leading-6 font-medium px-1.5 rounded-lg",
                    children: [
                        "Copied",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            "aria-hidden": "true",
                            width: "16",
                            height: "6",
                            viewBox: "0 0 16 6",
                            className: "text-color10 absolute top-full left-1/2 -mt-px -ml-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M15 0H1V1.00366V1.00366V1.00371H1.01672C2.72058 1.0147 4.24225 2.74704 5.42685 4.72928C6.42941 6.40691 9.57154 6.4069 10.5741 4.72926C11.7587 2.74703 13.2803 1.0147 14.9841 1.00371H15V0Z",
                                fill: "currentColor"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function Code(param) {
    var code = param.code, lang = param.lang, pad = param.pad;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
        className: (0,clsx_m/* default */.Z)("text-sm leading-6 text-gray-50 flex ligatures-none", pad && "overflow-auto"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
            className: (0,clsx_m/* default */.Z)("flex-none min-w-full", pad && "p-5"),
            dangerouslySetInnerHTML: {
                __html: code.split("\n").map(function(line) {
                    if (lang === "terminal") {
                        line = '<span class="flex"><svg viewBox="0 -9 3 24" aria-hidden="true" class="flex-none overflow-visible text-pink-400 w-auto h-6 mr-3"><path d="M0 0L3 3L0 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="flex-auto">'.concat(line, "</span></span>");
                    }
                    return line;
                }).join(lang === "terminal" ? "" : "\n")
            }
        })
    });
}
function Snippet(param) {
    var code = param.code, highlightedCode = param.highlightedCode;
    if (Array.isArray(code)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-span-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SnippetGroup, {
                actions: function(param) {
                    var selectedIndex = param.selectedIndex;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton, {
                        code: code[selectedIndex].code
                    });
                },
                children: code.map(function(param, index) {
                    var name = param.name, lang = param.lang;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor/* Editor */.M, {
                        filename: name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Code, {
                            code: highlightedCode[index],
                            lang: lang
                        })
                    }, name);
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-10 -ml-10 col-span-3 bg-gray-800 rounded-xl shadow-lg xl:ml-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabBar, {
                name: code.name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton, {
                    code: code.code
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Code, {
                    code: highlightedCode,
                    lang: code.lang,
                    pad: true
                })
            })
        ]
    });
}
function TabBar(param) {
    var name = param.name, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex text-gray-400 text-xs leading-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 flex-none text-sky-300 border-t border-b border-t-transparent border-b-sky-300 px-4 py-1 flex items-center",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-auto flex pt-2 rounded-tr-xl overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-auto -mr-px bg-gray-700/50 border border-gray-500/30 rounded-tl"
                })
            }),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-2 right-0 h-8 flex items-center pr-4",
                children: children
            })
        ]
    });
}


/***/ })

}]);